// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPlugOffIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M10 5.76 7.13 2.89C7.36 2.37 7.89 2 8.5 2c.83 0 1.5.67 1.5 1.5zM20 14v-4c0-1.1-.9-2-2-2h-1V3.5c0-.83-.67-1.5-1.5-1.5S14 2.67 14 3.5V8h-1.76l7.54 7.54c.13-.49.22-1 .22-1.54m.71 5.29-1.82-1.82L7 5.59 4.71 3.3A.996.996 0 1 0 3.3 4.71L6.59 8H6c-1.1 0-2 .9-2 2v4c0 3.31 2.69 6 6 6v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1c1.3 0 2.49-.41 3.47-1.11l1.82 1.82c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z" />
  </g>
);
export default SvgPlugOffIcon;
SvgPlugOffIcon.displayName = 'SvgPlugOffIcon';
